var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.34813 10.0569L8.19003 4.21501M2.34813 10.0569L2.42929 10.0406C4.52845 9.62079 6.37921 11.4716 5.95937 13.5707L5.94314 13.6519M2.34813 10.0569L1.44938 13.6519M8.19003 4.21501L11.0145 1.39049C11.2239 1.18108 11.4904 1.02913 11.7858 1.00837C13.6683 0.876085 15.124 2.33174 14.9916 4.21425C14.9709 4.50965 14.8189 4.77609 14.6095 4.98549L5.94314 13.6519M8.19003 4.21501C9.11977 3.89543 10.5902 4.04641 11.3356 4.66435M5.94314 13.6519L2.34813 14.5506M2.34813 14.5506L1.44938 15L1 14.5506L1.44938 13.6519M2.34813 14.5506V14.5506C2.53328 13.9952 2.00484 13.4667 1.44938 13.6519V13.6519",
    stroke: "#2F9CEB",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/Pencil.39d626f44f2b5be5d91f16976929d96a.svg";
export { ForwardRef as ReactComponent };